import React, { useEffect, useMemo, useState } from 'react';
import {
    getComponentAnalyticsComponentId,
    getComponentAnalyticsCounts,
} from '../utils/componentAnalytics';
import './MuultiStyle.css';

const formatCount = (value) => {
    const number = Number(value || 0);
    if (!Number.isFinite(number)) return '0';
    return new Intl.NumberFormat().format(number);
};

export default function ComponentAnalyticsSummary({
                                                      comp,
                                                      ownerPublicKey = '',
                                                      title = 'Audience activity',
                                                      compact = false,
                                                      footer = false,
                                                  }) {
    const componentId = getComponentAnalyticsComponentId(comp);
    const [counts, setCounts] = useState({ impression: 0, view: 0, interaction: 0 });
    const [loading, setLoading] = useState(false);

    const safeOwnerPublicKey = String(ownerPublicKey || comp?.ownerUid || comp?.ownerPublicKey || '').trim();
    const canLoad = !!safeOwnerPublicKey && !!componentId;

    useEffect(() => {
        if (!canLoad) return undefined;
        let mounted = true;
        setLoading(true);
        getComponentAnalyticsCounts({
            ownerPublicKey: safeOwnerPublicKey,
            componentId,
        })
            .then((nextCounts) => {
                if (mounted) setCounts(nextCounts);
            })
            .catch((error) => {
                console.warn('[component analytics] failed to load counts:', error);
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });
        return () => {
            mounted = false;
        };
    }, [canLoad, componentId, safeOwnerPublicKey]);

    const rows = useMemo(() => [
        { key: 'impression', label: 'Impressions', value: counts.impression },
        { key: 'view', label: 'Views', value: counts.view },
        { key: 'interaction', label: 'Interactions', value: counts.interaction },
    ], [counts]);

    if (!canLoad) return null;

    return (
        <section
            className={`component-analytics-summary${compact ? ' is-compact' : ''}${footer ? ' is-footer' : ''}`}
            aria-label={title}
        >
            {!footer && (
                <div className="component-analytics-summary__header">
                    <h4>{title}</h4>
                    {loading && <span>Updating...</span>}
                </div>
            )}
            <div className="component-analytics-summary__grid">
                {rows.map((row) => (
                    <div key={row.key} className="component-analytics-summary__stat">
                        <strong>{formatCount(row.value)}</strong>
                        <span>{row.label}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
